import { Slider, ColorPicker, Switch, Select, InputNumber } from 'antd';
import { useSketchProperitesContext } from '../../../../../context/SketchPropertiesContext';
import './SketchConfig.scss';

const TextConfig = () => {
  const { fontStyle, fontSize, textColour, halo, haloColour, haloStrength, haloRadius, setState } = useSketchProperitesContext();

  return (
    <>
      {/* Font */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">FONT</span>
        <div className="sketch-config__font-row">
          <Select
            className="sketch-config__flex"
            placeholder="Select Font Style"
            value={fontStyle}
            onChange={(value) => setState((prev) => ({ ...prev, fontStyle: value }))}
          >
            <Select.Option value="Arial">Arial</Select.Option>
            <Select.Option value="Verdana">Verdana</Select.Option>
            <Select.Option value="Times New Roman">Times New Roman</Select.Option>
            <Select.Option value="Georgia">Georgia</Select.Option>
            <Select.Option value="Courier New">Courier New</Select.Option>
            <Select.Option value="Trebuchet MS">Trebuchet MS</Select.Option>
            <Select.Option value="Tahoma">Tahoma</Select.Option>
            <Select.Option value="Impact">Impact</Select.Option>
          </Select>

          <Select
            className="sketch-config__flex"
            placeholder="Select Font Size"
            value={fontSize}
            onChange={(value) => setState((prev) => ({ ...prev, fontSize: value }))}
          >
            {[8, 10, 12, 14, 16, 18, 20, 24, 28, 32, 36, 40].map((size) => (
              <Select.Option key={size} value={size}>
                {size}px
              </Select.Option>
            ))}
          </Select>
        </div>
      </div>

      {/* Text Colour*/}
      <div className="sketch-config__row">
        <span className="sketch-config__label">TEXT COLOUR</span>
        <ColorPicker
          value={textColour}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              textColour: value.toHexString(),
            }));
          }}
          showText
        />
      </div>

      {/* Halo */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">HALO</span>
        <Switch
          value={halo}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              halo: value,
            }));
          }}
        />
      </div>

      {/* Halo Colour*/}
      <div className="sketch-config__row">
        <span className="sketch-config__label">HALO COLOUR</span>
        <ColorPicker
          value={haloColour}
          onChange={(value) => {
            setState((prev) => ({
              ...prev,
              haloColour: value.toHexString(),
            }));
          }}
          showText
        />
      </div>

      {/* Halo Strength*/}
      <div className="sketch-config__row">
        <span className="sketch-config__label">HALO STRENGTH</span>
        <Slider className="sketch-config__flex" value={haloStrength} onChange={(value) => setState((prev) => ({ ...prev, haloStrength: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={haloStrength}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              haloStrength: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="%"
        />
      </div>

      {/* Halo Radius */}
      <div className="sketch-config__row">
        <span className="sketch-config__label">HALO RADIUS</span>
        <Slider className="sketch-config__flex" value={haloRadius} onChange={(value) => setState((prev) => ({ ...prev, haloRadius: value }))} />
        <InputNumber
          className="sketch-config__input"
          value={haloRadius}
          onChange={(e) =>
            setState((prev) => ({
              ...prev,
              haloRadius: Number(e),
            }))
          }
          min={0}
          max={100}
          placeholder="%"
        />
      </div>
    </>
  );
};

export default TextConfig;
